var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeader',{attrs:{"image":_vm.FichadeInscricaoBannerImage,"ariaLabel":"Pessoas correndo","minHeight":421,"title":"Ficha de Inscrição","text":"Preencha os campos abaixo."}})}
var staticRenderFns = []

export { render, staticRenderFns }